import ReviewQueuePage from "@app/pages/sources/review-queue";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";

type ReviewSearch = { tab?: "decide" | "matched" | "all" };

export const Route = createFileRoute("/_authed/sources_/review")({
  // The active tab lives in the URL so a poll or a refresh never loses it.
  validateSearch: (search: Record<string, unknown>): ReviewSearch => ({
    tab: search.tab === "matched" || search.tab === "all" ? search.tab : search.tab === "decide" ? "decide" : undefined,
  }),
  head: () => pageHead("Review"),
  component: ReviewQueueRoute,
});

function ReviewQueueRoute() {
  return (
    <ErrorBoundary
      fallback={<div className="p-6 text-red-500">Error loading the review inbox</div>}
    >
      <Suspense
        fallback={<div className="p-6 text-gray-500">Loading the review inbox…</div>}
      >
        <ReviewQueuePage />
      </Suspense>
    </ErrorBoundary>
  );
}
